import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import formatDate from '@/services/general/formatDate';

export default function generateDataExcel(listeLigneVente, i18n, paramDimensionExportDcfCbaSpe) {
  const dataExcel = [];
  const heading = {
    reseau: i18n.t('exportExcelFaceSelect.columnExcel.reseau'),
    dateDepart: i18n.t('exportExcelFaceSelect.columnExcel.dateDepart'),
    reference: i18n.t('exportExcelFaceSelect.columnExcel.reference'),
    format: i18n.t('exportExcelFaceSelect.columnExcel.format'),
    largeur: i18n.t('exportExcelFaceSelect.columnExcel.largeur'),
    longueur: i18n.t('exportExcelFaceSelect.columnExcel.longueur'),
    materielType: i18n.t('exportExcelFaceSelect.columnExcel.materiel'),
    adresse: i18n.t('exportExcelFaceSelect.columnExcel.adresse'),
    codePostal: i18n.t('exportExcelFaceSelect.columnExcel.codePostal'),
    ville: i18n.t('exportExcelFaceSelect.columnExcel.ville'),
    restriction: i18n.t('exportExcelFaceSelect.columnExcel.restriction'),
    latitude: i18n.t('exportExcelFaceSelect.columnExcel.latitude'),
    longitude: i18n.t('exportExcelFaceSelect.columnExcel.longitude'),
  };
  if (!paramDimensionExportDcfCbaSpe) {
    delete heading.longueur;
    delete heading.largeur;
  }
  dataExcel.push(heading);
  listeLigneVente.forEach((ligne) => {
    const ligneVente = ligne.ligneVente;
    ligne.listeFace.forEach((face) => {
      const ligneExcel = {
        reseau: ligneVente.libelle,
        dateDepart: formatDate(ligneVente.dateDebut),
        reference: face.reference,
        format: face.format,
        longueur: face.longueur,
        largeur: face.largeur,
        materielType: face.materielType,
        adresse: adressFullStringGetter(face.adresse, true),
        ville: face.adresse.ville,
        codePostal: face.adresse.codePostal,
        restriction: face.restriction,
        latitude: face.adresse.latitude,
        longitude: face.adresse.longitude,
      };
      if (!paramDimensionExportDcfCbaSpe) {
        delete ligneExcel.longueur;
        delete ligneExcel.largeur;
      }

      dataExcel.push(ligneExcel);
    });
  });

  return dataExcel;
}
